import { Component , Prop , Mixins} from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import { COURSE_EVENTS } from '@/content/values/events';
import { CourseMultimediaObjectMixin } from '@/courses/mixins/course-multimedia-object.mixin';

@Component({name: 'ed-viewer-audio-object-component'})
export default class EdViewerAudioObjectComponent extends Mixins(CourseMultimediaObjectMixin) {

  /* Props */
  @Prop({default: null}) readonly section: Section; 
  @Prop({default: null}) readonly sectionMaterial: any;
  @Prop() isSolutionMaterial : boolean;
  
  /* Data */
  private audioElementType: string = 'audio';

  /* Computed */
  get audioFile(): string {
    if(this.sectionMaterial) return this.sectionMaterial.data.contentFileUrl || this.sectionMaterial.materialAssetInfo?.url;
    if(this.section.assetsInfo.length) return this.section.assetsInfo[0].url
  }

  /* Methods */
  private findAudioElement(): HTMLAudioElement {
    return (this.$refs.audioMultimedia as HTMLAudioElement);
  }

  mounted() {
    this.setMediaElement(this.findAudioElement(), this.audioElementType)
    if(this.isPresentationModeTeacher && !this.isSolutionMaterial && this.isCurrentBoardUserTeacher) {
      this.setTeacherListenerEvents();
    }
    if(this.isPresentationModeStudent) {
      this.$edEventBus.$on(COURSE_EVENTS.UPDATE_AUDIO_STATE, this.updateMediaElementState);
      this.setStudentInitalState();
    }
  }

  beforeDestroy() {
    if(this.isPresentationModeStudent) {
      this.$edEventBus.$off(COURSE_EVENTS.UPDATE_AUDIO_STATE, this.updateMediaElementState);
      this.$EdModal.closeModal();
    }
  }

}